import './ProfilePage.css'






const ProfilePage = () => {
    return (
        <div>ProfilePage</div>
    )
}

export default ProfilePage